import { render, staticRenderFns } from "./NewSubProductForm.vue?vue&type=template&id=d13b943a&scoped=true"
import script from "./NewSubProductForm.vue?vue&type=script&lang=js"
export * from "./NewSubProductForm.vue?vue&type=script&lang=js"
import style0 from "./NewSubProductForm.vue?vue&type=style&index=0&id=d13b943a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13b943a",
  null
  
)

export default component.exports